import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { pesquisaMenuItems, type PesquisaMenuItem } from './menuPesquisaItems';

const menuStyle = {
  background: '#c33764',
  color: '#fff',
  borderRadius: 1.5,
  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  minWidth: 320,
};

const itemStyle = {
  '&:hover': {
    backgroundColor: '#fca138',
    color: '#fff',
  },
  fontWeight: 500,
  px: 2,
  py: 1,
  whiteSpace: 'normal',
};

const MenuPesquisa: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderMenuItems = (items: PesquisaMenuItem[], depth = 0): React.ReactNode[] =>
    items.flatMap((item) => {
      const hasChildren = Boolean(item.children?.length);
      const current = (
        <MenuItem
          key={item.path}
          onClick={handleClose}
          component={Link}
          to={item.path}
          sx={{
            ...itemStyle,
            pl: 2 + depth * 2,
            py: depth > 0 ? 0.75 : 1,
            fontWeight: hasChildren ? 800 : depth > 0 ? 500 : 600,
            fontSize: depth > 0 ? '0.9rem' : '0.95rem',
          }}
        >
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            {depth > 0 ? (
              <Box
                component="span"
                sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#fca138', flex: '0 0 auto' }}
              />
            ) : null}
            {item.label}
          </Box>
        </MenuItem>
      );

      return item.children?.length ? [current, ...renderMenuItems(item.children, depth + 1)] : [current];
    });

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ExpandMoreIcon />}
        aria-controls={open ? 'menu-pesquisa' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{ color: '#fff', textTransform: 'none', fontWeight: 500, fontSize: '16px' }}
      >
        Pesquisa e Inovação
      </Button>
      <Menu
        id="menu-pesquisa"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: menuStyle }}
      >
        {renderMenuItems(pesquisaMenuItems)}
      </Menu>
    </>
  );
};

export default MenuPesquisa;